var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnitedKingdomFlag = function SvgUnitedKingdomFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "744.5 921.5 300 150",
    xmlSpace: "preserve"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M744.5 921.5h299.843v149.983H744.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF142B",
    d: "M879.428 1011.444v60.039h29.988v-60.039h134.928V981.46H909.416V921.5h-29.988v59.96H744.5v29.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00247D",
    d: "M919.415 970.049V921.5h97.08zM919.415 1022.933v48.55h97.08zM869.428 1022.933v48.55h-97.079zM869.428 970.049V921.5h-97.079zM744.501 935.442v36.051h72.087zM1044.343 935.442v36.051h-72.087zM1044.343 1057.541v-36.051h-72.087zM744.501 1057.541v-36.051h72.087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF142B",
    d: "M1044.343 921.5h-16.654L927.9 971.493h16.654L1044.5 921.5M860.943 1021.487h-16.654L744.5 1071.48h16.654l99.946-49.993M827.768 971.532h16.653L744.5 921.5v8.385zM961.023 1021.468h-16.654l99.921 50.032v-8.385z"
  })))));
};
export default SvgUnitedKingdomFlag;